import { c as _c } from "react/compiler-runtime";
import React from 'react';
import type { User } from '@/entities/User/types/user';
import type { Ileader } from '../../types/ILeader';
import { DotDivider } from '../DotDivider';
import { LeaderItem } from '../LeaderItem';
import { useGroupedLeadersyRank } from './useGroupedLeadersyRank';
interface IProps {
  dataList?: Ileader[];
  user: User | null;
}

// const EmptyGroup = ({percentile}: {percentile: number}) => {
//   return (
//     <div className="flex min-h-[74px] w-full flex-col items-center justify-center gap-2 rounded-[16px] bg-[#31324B59] px-2 py-2 pb-4 sm-tablet:px-4  sm-tablet:py-4 sm-tablet:pb-4">
//       <div className="flex items-center justify-center gap-2">
//         <span className="mt-[2px] text-center text-[12px] font-bold uppercase leading-[1] text-white sm-tablet:mt-0 sm-tablet:text-[16px]">
//           Top
//         </span>
//         <strong className="text-[16px] font-extrabold uppercase leading-[1] text-white sm-tablet:text-[20px]">
//           {percentile}%
//         </strong>
//       </div>
//     </div>
//   );
// };

const Group = t0 => {
  const $ = _c(10);
  const {
    percentile,
    leaders
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-[12px] font-bold uppercase text-white sm-tablet:text-[16px]">Top</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== percentile) {
    t2 = <div className="flex w-full max-w-12 flex-col justify-center ">{t1}<strong className="text-[16px] font-extrabold uppercase text-white sm-tablet:text-[20px]">{percentile}%</strong></div>;
    $[1] = percentile;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== leaders) {
    t3 = leaders.map(_temp);
    $[3] = leaders;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="flex w-full flex-col gap-1 sm-tablet:gap-2">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className="flex min-h-[74px] w-full items-center justify-center gap-2 rounded-[16px] bg-[#31324B59] px-4 py-2 sm-tablet:py-4">{t2}{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export const LeaderList = t0 => {
  const $ = _c(22);
  const {
    dataList,
    user
  } = t0;
  let t1;
  if ($[0] !== dataList || $[1] !== user) {
    t1 = {
      dataList,
      user
    };
    $[0] = dataList;
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    groups,
    currentUserFromNoTop
  } = useGroupedLeadersyRank(t1);
  let t2;
  if ($[3] !== groups[10]) {
    t2 = groups[10].length > 0 && <Group percentile={10} leaders={groups[10]} />;
    $[3] = groups[10];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== groups[20]) {
    t3 = groups[20].length > 0 && <Group percentile={20} leaders={groups[20]} />;
    $[5] = groups[20];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== groups[30]) {
    t4 = groups[30].length > 0 && <Group percentile={30} leaders={groups[30]} />;
    $[7] = groups[30];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== groups[40]) {
    t5 = groups[40].length > 0 && <Group percentile={40} leaders={groups[40]} />;
    $[9] = groups[40];
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== groups[50]) {
    t6 = groups[50].length > 0 && <Group percentile={50} leaders={groups[50]} />;
    $[11] = groups[50];
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== currentUserFromNoTop) {
    t7 = currentUserFromNoTop && <><DotDivider size="small" className="mx-auto my-4" /><LeaderItem data={currentUserFromNoTop} key={`CURRENT-${currentUserFromNoTop.userId}`} /></>;
    $[13] = currentUserFromNoTop;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <div className="flex w-full flex-col gap-3 sm-tablet:gap-4">{t2}{t3}{t4}{t5}{t6}{t7}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
function _temp(leader) {
  return <LeaderItem data={leader} key={leader.userId} />;
}